import { createAction, handleActions } from 'redux-actions';
import AT from '../actions/ActionTypes';
import { simpleStateMerge } from '../utils/reducerUtils';

const SET_ACCOUNT_DETAILS = 'SET_ACCOUNT_DETAILS';
const SET_AGENCY_DETAILS = 'SET_AGENCY_DETAILS';

const accountDefaults = {
  hostname: '',
  name: '',
};

export const setAccountDetails = createAction(SET_ACCOUNT_DETAILS);
export const setAgencyDetails = createAction(SET_AGENCY_DETAILS);

export const account = handleActions(
  {
    SET_ACCOUNT_DETAILS: (state, action) => {
      const newState = action.error ? state : simpleStateMerge(state, action);
      return newState;
    },
    SET_AGENCY_DETAILS: (state, action) => {
      return {
        ...state,
        agency: action.payload,
      };
    },
    [AT.FETCH_ACCOUNT_SUCCEEDED]: (state, action) => {
      return {
        ...state,
        policyHolderAccount: action.payload,
        orgData: action.payload.account || action.payload,
      };
    },
    [AT.UPDATE_ACCOUNT_SUCCEEDED]: (state, action) => {
      return {
        ...state,
        accountType: action.payload.account.accountType,
        id: action.payload.account.id,
        name: action.payload.account.name,
        type: action.payload.account.accountType,
      };
    },
    [AT.SEARCH_NAICS_CODES_SUCCEEDED]: (state, action) => {
      return {
        ...state,
        NAICSCodes: action.payload,
      };
    },
    [AT.GET_PROFILE_SCORE_SUCCEEDED]: (state, action) => {
      return {
        ...state,
        profileScore: action.payload,
      };
    },
    [AT.GET_PAYMENT_PROCESSOR]: (state, action) => {
      return {
        ...state,
        paymentProcessor: action.payload,
      };
    },
    [AT.UPDATE_EXCESS_DETAILS]: (state, action) => {
      return {
        ...state,
        excess: action.payload,
      };
    },

    [AT.USER_LOGOUT]: () => {
      return accountDefaults;
    },
  },
  accountDefaults
);
